import api from '@shared/services/api';

export const additionalAccessService = {
    // Get HR profiles by user ID - for access rights table
    getHrProfilesUsersByUserId: async (id) => {
        try {
            const response = await api.get(`/hr-profiles-users-by-user-id/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching HR profiles by user ID:', error);
            throw error;
        }
    },

    // Get current HR profiles users - for profile details
    getHrProfilesUsers: async (id) => {
        try {
            const response = await api.get(`/hr-profiles-users/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching HR profiles users:', error);
            throw error;
        }
    },

    // Update HR profiles users
    updateHrProfilesUsers: async (id, data) => {
        try {
            const response = await api.put(`/hr-profiles-users/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Error updating HR profiles users:', error);
            throw error;
        }
    },

    // Create new HR profiles users
    createHrProfilesUsers: async (data) => {
        try {
            const response = await api.post('/hr-profiles-users', data);
            return response.data;
        } catch (error) {
            console.error('Error creating HR profiles users:', error);
            throw error;
        }
    },

    // Delete HR profiles users
    deleteHrProfilesUsers: async (id) => {
        try {
            const response = await api.delete(`/hr-profiles-users/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting HR profiles users:', error);
            throw error;
        }
    }
};

